import {
  post, get
} from "./https"

//登录
export const login = p => post("/api/v1/window/login", p);
export const getUser = p => get("/api/v1/window/user/info", p);

export const config = p => get("/api/v1/window/user/rule", p);



export const aliOss = p => get("/api/manage/aliOss", p);

export const getCode = p => post('/api/manage/getCode', p)
export const loginByPhone = p => post('/api/manage/loginByModel', p)

export const member_list = p => get("/api/manage/member/list", p);
export const job_list = p => get("/api/manage/member/job/list", p);
export const job_add = (p, prm, a) => post("/api/manage/member/job/add", p, prm, a);
export const job_del = (p, prm, a) => post("/api/manage/member/job/del", p, prm, a);
export const job_edit = (p, prm, a) => post("/api/manage/member/job/edit", p, prm, a);
export const region_list = p => get("/api/manage/member/region/list", p);
export const region_add = (p, prm, a) => post("/api/manage/member/region/add", p, prm, a);
export const region_del = (p, prm, a) => post("/api/manage/member/region/del", p, prm, a);
export const region_edit = (p, prm, a) => post("/api/manage/member/region/edit", p, prm, a);

export const store_list = p => get("/api/manage/member/store/list", p);
export const store_add = (p, prm, a) => post("/api/manage/member/store/add", p, prm, a);
export const store_add_get = (p, prm, a) => get("/api/manage/member/store/add", p, prm, a);
export const store_edit_get = (p, prm, a) => get("/api/manage/member/store/edit", p, prm, a);
export const store_del = (p, prm, a) => post("/api/manage/member/store/del", p, prm, a);
export const store_edit = (p, prm, a) => post("/api/manage/member/store/edit", p, prm, a);
export const store_info = (p, prm, a) => get("/api/manage/member/store/info", p, prm, a);
export const association = (p, prm, a) => post("/api/manage/member/store/association", p, prm, a);
export const association_get = (p, prm, a) => get("/api/manage/member/store/association", p, prm, a);




export const member_add_get = (p, prm, a) => get("/api/manage/member/add", p, prm, a);
export const member_add = (p, prm, a) => post("/api/manage/member/add", p, prm, a);
export const member_edit_get = (p, prm, a) => get("/api/manage/member/edit", p, prm, a);
export const member_edit = (p, prm, a) => post("/api/manage/member/edit", p, prm, a);
export const member_info = (p, prm, a) => get("/api/manage/member/info", p, prm, a);
export const resetPassword = (p, prm, a) => post("/api/manage/member/resetPassword", p, prm, a);


export const selfChecking_create = (p, prm, a) => post("/api/manage/selfChecking/create", p, prm, a);
export const selfChecking_create_get = (p, prm, a) => get("/api/manage/selfChecking/create", p, prm, a);
export const selfChecking_question_get = (p, prm, a) => get("/api/manage/selfChecking/question", p, prm, a);

export const selfChecking_base = (p, prm, a) => post("/api/manage/selfChecking/base", p, prm, a);
export const selfChecking_base_get = (p, prm, a) => get("/api/manage/selfChecking/base", p, prm, a);
export const selfChecking_list = (p, prm, a) => get("/api/manage/selfChecking/list", p, prm, a);
export const selfChecking_user_get = (p, prm, a) => get("/api/manage/selfChecking/user", p, prm, a);
export const selfChecking_user = (p, prm, a) => post("/api/manage/selfChecking/user", p, prm, a);
export const selfChecking_release_get = (p, prm, a) => get("/api/manage/selfChecking/release", p, prm, a);
export const selfChecking_release = (p, prm, a) => post("/api/manage/selfChecking/release", p, prm, a);
export const selfChecking_operate = (p, prm, a) => post("/api/manage/selfChecking/operate", p, prm, a);
export const selfChecking_question = (p, prm, a) => post("/api/manage/selfChecking/question", p, prm, a);
export const selfChecking_operate_get = (p, prm, a) => get("/api/manage/selfChecking/operate", p, prm, a);
export const selfChecking_specialTime = (p, prm, a) => post("/api/manage/selfChecking/specialTime", p, prm, a);
export const selfChecking_specialTime_get = (p, prm, a) => get("/api/manage/selfChecking/specialTime", p, prm, a);


export const examine_people = p => get("/api/manage/selfChecking/examine/people", p);
export const examine_people_add = p => post("/api/manage/selfChecking/examine/people/add", p);
export const examine_people_edit = p => post("/api/manage/selfChecking/examine/people/edit", p);
export const examine_people_edit_get = (p, prm, a) => get("/api/manage/selfChecking/examine/people/edit", p, prm, a);
export const examine_people_edit_del = (p, prm, a) => post("/api/manage/selfChecking/examine/people/del", p, prm, a);
export const examine_project = (p, prm, a) => get("/api/manage/selfChecking/examine/project", p, prm, a);





export const project_list = p => get("/api/manage/project/list", p);

//培训
export const training_create_get = (p, prm, a) => get("/api/manage/training/create", p, prm, a);
export const training_create = (p, prm, a) => post("/api/manage/training/create", p, prm, a);






export const createProject_getProductType = p => get("/api/manage/createProject/getProductType", p);
export const createProject_getIndicators = (p, prm, a) => get("/api/manage/createProject/getIndicators", p, prm, a);
export const createProject_getBackgroundTopic = (p, prm, a) => get("/api/manage/createProject/getBackgroundTopic", p, prm, a);
export const createProject_create = p => post("/api/manage/createProject/create", p);
export const project_detail = (p, prm, a) => get("/api/manage/project/detail", p, prm, a);
export const uploadImg = (p, prm, a) => post("/api/manage/uploadImg", p, prm, a);
export const project_template = (p, prm, a) => get("/api/manage/project/template", p, prm, a);
export const project_template_detail = (p, prm, a) => get("/api/manage/project/template/detail", p, prm, a);
export const member_info_p = (p, prm, a) => post("/api/manage/member/edit", p, prm, a);
export const member_password = (p, prm, a) => post("/api/manage/member/password", p, prm, a);
export const member_delete = (p, prm, a) => post("/api/manage/project/delete", p, prm, a);
export const member_getCode = (p, prm, a) => post("/api/manage/member/getCode", p, prm, a);
export const member_editPhone = (p, prm, a) => post("/api/manage/member/editPhone", p, prm, a);



//保存产品
export const postUrl = (url, p, prm, a) => post(url, p, prm, a);
export const getUrl = (url, p, prm, a) => get(url, p, prm, a);

